<template>
  <div class="upsell-tree-item">
    <div v-if="funnel.is_end">
      <strong>{{ funnel.name }}</strong>
      <div>Página de obrigado</div>
    </div>
    <div class="d-flex align-items-center" v-else>
      <img
        class="product-sm-picture"
        v-if="funnel.product.picture"
        :src="funnel.product.picture"
      />
      <img
        v-else
        class="product-sm-picture"
        :src="require('@/assets/images/product/product-placeholder.png')"
      />
      <div class="pl-lg-5 pl-3">
        <div v-if="!funnel.parent">
          <strong>Página de vendas</strong>
        </div>
        <div v-else>
          <strong>{{ funnel.name }}</strong>
        </div>

        <div>{{ funnel.product.name }}</div>
      </div>
    </div>
    <div v-if="!funnel.level" class="pt-lg-6 pt-5">
      <button
        class="btn btn-success w-100"
        @click="$emit('new-step')"
        id="start"
        :disabled="funnels.length > 1"
      >
        Início
      </button>
    </div>
    <div v-else class="pt-lg-6 pt-5">
      <button
        :disabled="funnel.action_yes"
        :id="'yes' + funnel.id"
        v-if="funnel.cta_text"
        class="btn btn-success btn-block mt-3"
        @click="$emit('action-yes')"
      >
        {{ formatLongText(funnel.cta_text) }}
      </button>
      <button
        :disabled="funnel.action_no"
        :id="'no' + funnel.id"
        v-if="funnel.ctb_text"
        class="btn btn-danger btn-block mt-3"
        @click="$emit('action-no')"
      >
        {{ formatLongText(funnel.ctb_text) }}
      </button>
      <hr />
      <div class="row">
        <div class="col-6 d-flex align-items-center justify-content-start">
          <button class="btn btn-outline-primary p-3 mr-3">
            <i class="fa-solid fa-pen" @click="$emit('edit')" />
          </button>
          <!-- <button class="btn btn-outline-primary p-3">
            <i class="icon-code" />
          </button> -->
        </div>
        <div class="col-6 d-flex align-items-center justify-content-end">
          <button
            class="btn btn-outline-danger p-3"
            @click="confirmation = true"
          >
            <i class="icon-trash" />
          </button>
        </div>
      </div>
    </div>

    <confirmation
      title="Aviso"
      iconType="warning"
      v-model="confirmation"
      cancelButtonText="Cancelar"
      text="Tem certeza de que deseja deletar essa etapa?"
      @confirm="$emit('delete')"
      @cancel="confirmation = false"
    />
  </div>
</template>

<script>
import LeaderLine from "leader-line-vue";
import { mapState } from "vuex";

export default {
  props: {
    funnel: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      timeout: null,
      confirmation: false,
      line_start: null,
      line_yes: null,
      line_no: null
    };
  },
  computed: {
    ...mapState("funnel", ["funnels"]),
    firstStep() {
      return this.funnels.find(f => f.level == 1).id;
    }
  },
  mounted() {
    setTimeout(() => {
      const resizeObj = new ResizeObserver(() => {
        this.removeLines();

        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.createLines();
        }, 100);
      });

      resizeObj.observe(document.querySelector("#view-product-upsell-tree"));
    }, 500);
  },
  methods: {
    formatLongText(txt) {
      if (txt) {
        return txt.length > 20 ? `${txt.slice(0, 20)}...` : `${txt}`;
      }
      return "-";
    },
    createLines() {
      const path =
        document.querySelector("#view-product-upsell-tree").offsetWidth >= 768
          ? "magnet"
          : "straight";

      if (this.funnel.action_yes) {
        this.line_yes = LeaderLine.setLine(
          document.getElementById("yes" + this.funnel.id),
          document.getElementById(this.funnel.action_yes.id),
          {
            path,
            color: "#04C56B"
          }
        );
      }
      if (this.funnel.action_no) {
        this.line_no = LeaderLine.setLine(
          document.getElementById("no" + this.funnel.id),
          document.getElementById(this.funnel.action_no.id),
          {
            path,
            color: "#FF3F34"
          }
        );
      }
      if (this.funnel.level === 0 && this.funnels.length > 1) {
        this.line_start = LeaderLine.setLine(
          document.getElementById("start"),
          document.getElementById(this.firstStep),
          {
            path,
            color: "#04C56B"
          }
        );
      }
    },
    removeLines() {
      ["line_no", "line_yes", "line_start"].forEach(i => {
        if (this[i]) {
          this[i].remove();
          this[i] = null;
        }
      });
    }
  },
  beforeDestroy() {
    this.removeLines();
  }
};
</script>
]

<style lang="scss" scoped>
.upsell-tree-item {
  min-width: 100%;
  border: 1px solid lightgrey;
  border-radius: 8px;
  background-color: white;
  padding: 15px;

  i {
    font-size: 30px;
  }

  @media screen and (max-width: 767px) {
    font-size: 10px;

    .product-sm-picture {
      width: 32px;
    }

    .btn {
      font-size: 10px;
      min-height: 32px;

      i {
        font-size: 20px;
      }
    }
  }
}
</style>
